import React, { useEffect, useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AdminContext } from "../contexts/AdminContext";
import { ScreenContext } from "../contexts/ScreenContext";

import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";

import { blue } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  formControl: {
    marginTop: 10,
    marginBottom: 15,
  },
  save: {
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[500],
    "&:hover": {
      backgroundColor: blue[700],
    },
    borderColor: blue[700],
    lineHeight: 2,
  },
}));

const DailyMessageForm = () => {
  const classes = useStyles();
  const {
    saveDailyMessage,
    getDailyMessage,
    isDailyMessageSaving,
    dailyMessage,
  } = useContext(AdminContext);
  const { setSnackbarMessage } = useContext(ScreenContext);
  const [loadedDailyMessage, setDailyMessage] = useState("");
  const [isInit, setIsInit] = useState(false);

  const handleDailyMessageSave = () => {
    // Validate message length (allow empty to clear the message)
    if (loadedDailyMessage.length > 1000) {
      setSnackbarMessage({ message: 'Message is too long. Maximum 1000 characters allowed.', severity: 'error' });
      return;
    }
    saveDailyMessage(isInit, loadedDailyMessage);
  };

  const handleDailyMessageChange = (event) => {
    setDailyMessage(event.target.value);
  };

  useEffect(() => {
    if (dailyMessage.length) {
      setDailyMessage(dailyMessage[0].value);
      setIsInit(true);
    }
  }, [dailyMessage]);

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      getDailyMessage();
    }

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <React.Fragment>
      <FormControl
        variant="outlined"
        className={classes.formControl}
        fullWidth={true}
      >
        <TextField
          id="daily-message-text"
          name="dailyMessage"
          label={`DAILY MESSAGE ${isDailyMessageSaving ? " - SAVING..." : ""}`}
          multiline
          rows={4}
          value={loadedDailyMessage}
          onChange={handleDailyMessageChange}
          variant="outlined"
          autoComplete="off"
          helperText={`${loadedDailyMessage.length}/1000 characters`}
          error={loadedDailyMessage.length > 1000}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </FormControl>
      <Grid container justifyContent="flex-end">
        <Grid item>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleDailyMessageSave}
            className={classes.save}
            disableElevation
            disabled={loadedDailyMessage.length > 1000}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default DailyMessageForm;
